/**
 * Shared styled components for Settings Modals
 * Used across 28+ cover image variation components
 */
import styled, { css } from 'styled-components';

import { StyledDialog } from '@/components/AlertDialogs/Dialog';
import { RadiosLabel } from '@/components/Forms';
import Text from '@/components/Text';
import { scrollBarStyles } from '@/utils/theme';

export const Dialog = styled(StyledDialog)`
  width: 600px;
  padding: 0;
  text-align: left;
`;

export const StyledRadiosLabel = styled(RadiosLabel)`
  text-transform: capitalize;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  padding: 24px;
  position: relative;
  box-shadow: 0px 2px 8px rgba(34, 34, 34, 0.06);
`;

export const ModalContent = styled.div`
  padding: 24px 32px 56px;
  display: grid;
  row-gap: 24px;
  max-height: calc(90vh - 174px);
  overflow-y: auto;
  ${scrollBarStyles};
`;

export const ActionBox = styled.div<{ $columns?: number }>`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  padding: 24px;
  display: flex;
  gap: 32px;

  ${({ $columns }) =>
    $columns &&
    css`
      display: grid;
      grid-template-columns: repeat(${$columns}, 1fr);
      gap: 16px 32px;
    `}
`;

export const ActionTitle = styled(Text)`
  margin-bottom: 8px;
`;
